<template>
	<div class="photo-grid" :class="[`photo-grid-${grid}`]">
		<template v-for="image in images">
			<div class="port-image" :class="image.aspect || 'wide'">
				<img
					draggable="false"
					:src="img_src(image)"
					@click="$emit('updateModal', img_src(image))"
					class="img-fluid"
				/>
			</div>
		</template>
	</div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import Fade from "@/components/Transitions/Fade.vue";
const {
	images = [],
	src = "/assets/",
	grid = 6,
} = defineProps(["images", "src", "grid"]);

const emits = defineEmits(["updateModal"]);

function img_src(image) {
	return src + (image.fp || image);
}

function hover_preload(event) {
	console.log("preloading src");
	modalImage.value.src = event.target.src.replace("thumbnail", "full_sized");
}
</script>
